import {combineReducers} from 'redux';
import {reducer as LoginReducer} from './login/LoginRedux';
import UserReducer from './user'
import PatientReducer from './patient'

const appReducer = combineReducers({
  login: LoginReducer,
  user: UserReducer,
  patient: PatientReducer,
});

export default (state, action) => {
  if (action.type === 'CREATE_LOGOUT_SUCCESS')
    state = undefined;

  return appReducer(state, action);
}

